import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCartIcon, HeartIcon } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { Product } from '../context/ProductContext';
interface ProductCardProps {
  product: Product;
}
export const ProductCard: React.FC<ProductCardProps> = ({
  product
}) => {
  const {
    addToCart
  } = useCart();
  const handleAddToCart = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    addToCart({
      id: product.id,
      name: product.name,
      price: product.price,
      image: product.image
    });
  };
  return <Link to={`/product/${product.id}`} className="group" data-id="element-270">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md overflow-hidden transition-transform duration-300 group-hover:shadow-lg group-hover:-translate-y-1" data-id="element-271">
        <div className="relative aspect-square overflow-hidden" data-id="element-272">
          <img src={product.image} alt={product.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-273" />
          {product.discount && <span className="absolute top-2 right-2 bg-red-500 text-white text-xs font-bold px-2 py-1 rounded" data-id="element-274">
              {product.discount}% SOODSAM
            </span>}
        </div>
        <div className="p-4" data-id="element-275">
          <h3 className="font-medium text-gray-900 dark:text-white mb-1 truncate" data-id="element-276">
            {product.name}
          </h3>
          <div className="flex items-end mb-3" data-id="element-277">
            <span className="text-lg font-bold text-gray-900 dark:text-white" data-id="element-278">
              {product.price.toLocaleString()}€
            </span>
            {product.originalPrice && <span className="ml-2 text-sm text-gray-500 dark:text-gray-400 line-through" data-id="element-279">
                {product.originalPrice.toLocaleString()}€
              </span>}
          </div>
          <div className="flex space-x-2" data-id="element-280">
            <button onClick={handleAddToCart} className="flex-1 bg-yellow-500 hover:bg-yellow-600 text-white py-2 px-4 rounded-md text-sm font-medium flex items-center justify-center transition-colors" data-id="element-281">
              <ShoppingCartIcon size={16} className="mr-1" data-id="element-282" /> Lisa Ostukorvi
            </button>
            <button className="p-2 border border-gray-300 dark:border-gray-600 rounded-md text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors" data-id="element-283">
              <HeartIcon size={16} data-id="element-284" />
            </button>
          </div>
        </div>
      </div>
    </Link>;
};